import {Button, Dropdown, Tag} from '@/components/atoms'
import {useSegmentsGroup} from '@/hooks/promotion/segments/useSegmentsGroup'
import {segmentOptions} from '@/utils/constants/promotionConstants'
import {SegmentTags} from '../SegmentModal/SegmentTags'
import './segmentGroup.scss'

export const SegmentGroup = ({groupIndex, segmentGroup, onSegmentSelection}) => {
  const {handleDeleteGroup, handleRemove} = useSegmentsGroup()
  const allSegmentIds = segmentGroup?.segments || []

  const canDelete = groupIndex > 0 && handleDeleteGroup !== null
  const totalSelections = allSegmentIds.length

  const getSelectionText = () => {
    if (totalSelections === 0) return null
    if (totalSelections === 1) return 'One selected'
    return 'Multiple selected'
  }

  return (
    <div className="mb-6">
      <div className="mb-4 flex items-center justify-start">
        <div className="products-admin-segment-section-tag-wrapper relative flex items-center gap-2">
          <Dropdown
            isJsonWrap={false}
            childList={segmentOptions}
            isDark
            placeholder="Select Segment(s)"
            label={groupIndex !== null ? `Group ${groupIndex + 1}` : 'Segments'}
            updateValue={items => onSegmentSelection(items, groupIndex)}
            autocomplete="off"
          />

          {totalSelections > 0 && (
            <>
              <div className="selection-overlay pointer-events-none absolute left-0 flex w-full items-center px-3">
                <span className="bg-[#272727] text-sm text-white">{getSelectionText()}</span>
              </div>
              <Tag text={`${totalSelections}`} color="blue" className="absolute right-0 mt-5" />
            </>
          )}
        </div>

        {canDelete && (
          <Button
            handleButton={() => handleDeleteGroup(groupIndex)}
            uiSchema={{
              className: 'ml-4 mt-5',
              size: 'small',
              variant: 'tertiary',
            }}
          >
            Delete Group
          </Button>
        )}
      </div>

      <div className="mt-4">
        <SegmentTags
          segments={allSegmentIds}
          handleTagRemove={segment => handleRemove(segment.segmentId, groupIndex)}
          color="green"
          showAnd
        />
      </div>
    </div>
  )
}
